import React from 'react';
import './Clients.css';

const Clients = () => {
  const testimonials = [
    {
      quote: 'SCE Automated delivered an exceptional automation solution that transformed our production line. Their expertise and attention to detail were outstanding.',
      author: 'Manufacturing Director',
      company: 'Leading Automotive Manufacturer'
    },
    {
      quote: 'Working with SCE Automated was a great experience. They understood our requirements and delivered a solution that exceeded our expectations.',
      author: 'Operations Manager',
      company: 'Medical Device Company'
    },
    {
      quote: 'The automation system from SCE Automated has significantly improved our efficiency and product quality. Highly recommended.',
      author: 'Plant Manager',
      company: 'Consumer Products Manufacturer'
    }
  ];

  return (
    <div className="clients-page">
      <section className="page-hero">
        <div className="container">
          <h1>Our Clients</h1>
          <p className="page-hero-subtitle">
            Trusted by leading manufacturers across diverse industries
          </p>
        </div>
      </section>

      <section className="clients-content">
        <div className="container">
          <div className="clients-intro">
            <p>
              SCE Automated is proud to serve manufacturers across various industries. 
              Our clients range from small and medium-sized businesses to large 
              multinational corporations. We are committed to building long-term 
              partnerships based on trust, quality, and results.
            </p>
          </div>

          <div className="clients-list-section">
            <h2>Our Clients</h2>
            <div className="clients-grid">
              <div className="client-logo">
                <div className="client-name">Aptiv</div>
                <div className="client-type">Automotive</div>
              </div>
              <div className="client-logo">
                <div className="client-name">Robert Bosch</div>
                <div className="client-type">Automotive</div>
              </div>
              <div className="client-logo">
                <div className="client-name">Festo</div>
                <div className="client-type">Automation Brand</div>
              </div>
              <div className="client-logo">
                <div className="client-name">BBS Automation</div>
                <div className="client-type">Global OEM Machine Builder</div>
              </div>
              <div className="client-logo">
                <div className="client-name">Cordis</div>
                <div className="client-type">Medical</div>
              </div>
              <div className="client-logo">
                <div className="client-name">Cummins</div>
                <div className="client-type">Automotive</div>
              </div>
              <div className="client-logo">
                <div className="client-name">Rainbird</div>
                <div className="client-type">Irrigation Products</div>
              </div>
              <div className="client-logo">
                <div className="client-name">Rivian</div>
                <div className="client-type">Automotive</div>
              </div>
            </div>
          </div>

          <div className="testimonials-section">
            <h2>What Our Clients Say</h2>
            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-quote">
                    <span className="quote-mark">"</span>
                    <p>{testimonial.quote}</p>
                  </div>
                  <div className="testimonial-author">
                    <p className="author-name">{testimonial.author}</p>
                    <p className="author-company">{testimonial.company}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="clients-cta">
            <h2>Become Our Next Success Story</h2>
            <p>Join the growing list of manufacturers who trust SCE Automated for their automation needs</p>
            <a href="/contact" className="btn btn-primary">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clients;

